module.exports={cookies:"Cookie",help:"帮助",privacy:"隐私（已更新）",signInWithId:"使用 Adobe ID 登录",termsOfUse:"使用条款"};